import React, { Fragment, useEffect, useState } from 'react';
import Banner from './Banner';
import WorkflowSteps from './WorkflowSteps';
import InlineInvoiceDemo from './InlineInvoiceDemo';
import OurFeatures from './OurFeatures';
import AudienceSection from './AudienceSection';
import SocialProofStats from './SocialProofStats';
import Testimonial from './Testimonial';
import PricingTeaser from './PricingTeaser';
import Trial from './Trial';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

function HomeMain(){
    const { t, locale } = useLocale();

    const[loader, SetLoader] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        }, 1000)

        return () => clearTimeout(timer)
    }, [])

    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <PageSEO title={t('meta.homeTitle')} description={t('meta.homeDescription')} path="/" locale={locale} />
            <Banner />
            <SocialProofStats />
            <WorkflowSteps />
            <InlineInvoiceDemo />
            <OurFeatures />
            <AudienceSection />
            <PricingTeaser />
            <Testimonial />
            <Trial />
            <Footer />
        </Fragment>
    )
}

export default HomeMain;